<template>
	<grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_SALES_ORDER)"
        :canDelete="checkClaim(CAN_DELETE_SALES_ORDERS)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="fields"
        :handleRowClick="onRowClick"
      />
</template>

<script>
import { mapGetters } from 'vuex';

import { dateTime, date } from '@/shared/filters';
import { GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
	components: {
		GridSettings,
		GridComponent
	},
	props: {
		salesOrderId: {
			type: [String, Number],
			default: 0
		},
		isFilteredList: {
			type: Boolean,
			default: false
		},
		salesOrderSchedulesFiltered: {
			type: Array,
			default: () => []
		},
		showCheckbox: {
			type: Boolean,
			default: false
		},
		gridId: {
			type: String,
			default: GRID_ID.SALES_ORDER_LINE_SCHEDULES
		}
	},
	data() {
		return {
			prepareColumnsData,
			fields: gridFields,
			selectedRowItemId: 0,
			checkedRowItemIds: []
		};
	},
	computed: {
		...mapGetters('salesorderlineschedules', [ 'salesOrderLineSchedulesList' ]),
		...mapGetters('account', ['gridSettingsById']),
		itemData() {
			const listItems = this.isFilteredList ? this.salesOrderSchedulesFiltered : this.salesOrderLineSchedulesList;

			if(listItems == undefined || listItems.length === 0) return [];
			return listItems.map((SalesOrderLineSchedules) => ({ ...SalesOrderLineSchedules, selected: SalesOrderLineSchedules.id === this.selectedRowItemId }));
		},
		gridSettings() {
			return this.gridSettingsById(this.gridId);
		}
	},
	filters: {
		dateTime,
		date
	},
	methods: {
		// ...mapMutations('salesorderlineschedules', [ 'setSalesOrderLineSchedulesList' ]),
		// ...mapActions('salesorderlineschedules', [ 'getSchedulesBySalesOrderId' ]),
		onRowClick(e) {
			this.selectedRowItemId = e.dataItem.id;
			this.$emit('selectedSOSchedule', e.dataItem);
		}
	},
	watch: {
		checkedRowItemIds() {
			this.$emit('updateCheckedRowItemIds', this.checkedRowItemIds);
		},
	}
};
</script>
